module.exports = __webpack_public_path__ + "img/testimonials.ec96b420.jpg";